
import {
  minLength,
  required
} from "vuelidate/lib/validators";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: "FormFeedback",

  data: function () {
    return {
      form: {
        name: "",
        phone: ""
      },
      isAccept: true
    }
  },

  computed: {
    errorName: function () {
      const error = this.$v?.form?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },

    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },
  },

  validations: function () {
    const form = {
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(18)
      },
    };

    return {
      form,
    };
  },

  methods: {
    resetForm: function () {
      this.form = {
        name: "",
        phone: "",
        message: "",
      };
      this.$v.$reset();
    },
    submitForm: async function (codeRecaptcha = '') {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      let body = {
        type: "Обратный звонок",
        name: this.form.name,
        phone: (this.form?.phone || "").replace(/[^\d]/g, ''),
        message: this.form?.message,
        url: window.location.href
      };

      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });
      const utmLabels = parseUtmLabels();
      if (utmLabels) {
        body.additional_data = {
          ...(body.additional_data || {}),
          ...utmLabels
        }
      }
      body.source = this.$cookies.get('sbjs_current') || '';
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });
      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
        this.$toast.error(response.error);

        return
      }

      this.$yandexMetrika.reachGoal("peresvonut_mne");
      this.$yaglaaction('peresvonut_mne');
      this.resetForm();
      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");
    }
  }
}
